<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="seguroForm.nombre"
              label="Nombre"
              outlined
              :rules="[
                () => !!seguroForm.nombre || 'Es necesario ingresar un nombre',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="seguroForm.monto"
              label="Monto"
              outlined
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="seguroForm.porcentaje"
              label="Porcentaje"
              outlined
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      seguroForm: {
        id: null,
        nombre: null,
        monto: null,
        porcentaje: null,
      },
    };
  },
  methods: {
    ...mapActions("seguros", ["store", "update"]),
    async showForm(title, action, seguro = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (seguro) {
        this.setSeguro(seguro);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      //this.regimenForm = null;
      this.seguroForm.nombre = null;
      this.seguroForm.monto = null;
      this.seguroForm.porcentaje = null;

      //this.clearErrors();
    },
    setSeguro(seguro) {
      this.seguroForm.id = seguro.id;
      this.seguroForm.nombre = seguro.nombre;
      this.seguroForm.monto = seguro.monto;
      this.seguroForm.porcentaje = seguro.porcentaje;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      // console.log('aqui')
      await this.store(this.seguroForm);
      this.closeForm();
      /*if (!this.existErrors()) {

            }*/
    },
    async handleUpdate() {
      await this.update(this.seguroForm);
      this.closeForm();
      /*if (!this.existErrors()) {
                await this.store(this.regimenForm);
                this.closeForm();
            }*/
    },
  },
};
</script>

<style scoped></style>
